export default () => {
  const data = {
    event_name: 'click',
    button_name: 'to_brokers',
    page_section: 'header',
    name_of_the_page_viewed: 'development_list_personal',
  };
  return data;
};
